































































import { Portal } from '@linusborg/vue-simple-portal';
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import Confirm from '@/vue3/components/Confirm.vue';
import Dialog from 'primevue/dialog';
import { formatDistanceToNow } from 'date-fns';

import {
    ref,
    defineComponent,
} from '@vue/composition-api';

import { useStore } from '@/store';

interface Comment {
    commentByAccountId?: number;
    commentByAccountName?: string;
    commentedTimestamp?: string;
    content?: string;
    geoRecordId: number;
}

export default defineComponent({
    name: 'CommentSection',
    components: {
        Card,
        InputText,
        Button,
        Textarea,
        Portal,
        Confirm,
        Dialog
    },
    props: {
        comments: {
            type: Array as () => Comment[],
            required: true,
        },
        geoRecordId: {
            type: Number,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false
        },
    },
    setup(props, { emit }) {
        const store = useStore();
        const newComment = ref('');
        const selectedCommentId = ref(0);
        const isDeleteVisible = ref(false);
        const currentUserAccountId = store.getters.account.id;

        const addComment = () => {
            if (newComment.value.trim()) {
                const newCommentObj: Comment = {
                    content: newComment.value.trim(),
                    geoRecordId: props.geoRecordId
                };
                emit('addComment', newCommentObj);
                newComment.value = '';
            }
        };

        const showDeleteCommentModal = (commentId: number) => {
            selectedCommentId.value = commentId;
            isDeleteVisible.value = true;
        }

        const hideDeleteCommentModal = () => {
            isDeleteVisible.value = false;
            selectedCommentId.value = 0;
        }

        const deleteComment = () => {
            emit('deleteComment', selectedCommentId.value);
            hideDeleteCommentModal()
        };

        const formatTimeAgo = (timestamp: string) => {
            return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
        };

        return {
            newComment,
            currentUserAccountId,
            addComment,
            deleteComment,
            formatTimeAgo,
            isDeleteVisible,
            showDeleteCommentModal,
            hideDeleteCommentModal
        };
    },
});
